module.exports = __webpack_public_path__ + "static/media/cert_28.11e82ac5.jpg";